import React from 'react';
import { Card } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { CHUNGNHAN_API } from '@app/utils/apiUrl';
import { Post } from '@app/utils/httpProvider';
import { messageError, messageToast, status200 } from '../../../../utils/define';
import { URI_INTERNAL } from '../../../../utils/pathLocations';
import ChungNhanForm from './ChungNhanForm';
import { useMutation, useQueryClient } from 'react-query';

const schema = yup.object().shape({
    tenNguoiNhan: yup.string().trim().required(messageError.emptyMessage),
    diaChiNguoiNhan: yup.string().trim().required(messageError.emptyMessage),
    trichYeuId: yup.string().uuid(messageError.emptyMessage).notOneOf(['00000000-0000-0000-0000-000000000000'], messageError.emptyMessage).required(messageError.emptyMessage),
    fileManagerId: yup.string().uuid(messageError.emptyMessage).notOneOf(['00000000-0000-0000-0000-000000000000'], messageError.emptyMessage).required(messageError.emptyMessage)
});

const ChungNhanAdd = () => {
    const history = useHistory();
    const queryClient = useQueryClient();

    const addFunc = useMutation((value) =>
        Post(CHUNGNHAN_API.ADD_ITEM, null, value, false)
    );

    const handleCreate = async (values) => {
        const model = values;

        addFunc.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastCreateError);
                } else {
                    toast.success(messageToast.messageToastCreateSuccess);
                    queryClient.invalidateQueries('chungNhanData');
                    history.push(URI_INTERNAL.CHUNGNHAN_PATH);
                }
            },
            onError: (res) => {
                toast.error(
                    res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                );
            }
        });
    };

    return (
        <Card>
            <Card.Header as="h5">Thêm mới chứng nhận</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values) => handleCreate(values)}
                    initialValues={{
                        tenNguoiNhan: '',
                        diaChiNguoiNhan: '',
                        trichYeuId: '',
                        fileManagerId: '',
                        description: ''
                    }}
                >
                    {(formik) => (
                        <ChungNhanForm formik={formik} isSaving={addFunc.isLoading} isEdit={false} />
                    )}
                </Formik>
                {addFunc.isLoading && <div>Đang lưu...</div>}
            </Card.Body>
        </Card>
    );
};

export default ChungNhanAdd;
